import React from "react";
import { useNavigate } from "react-router-dom";

import {
  TABLE_DATA,
  TABLE_HEADERS,
  keyMapping,
  topDataList,
} from "../../../../constants/SalesPaymentRecieptList";

import ListPage from "../Shared/ListPage";
import ROUTES_NAVIGATION from "../../../../routes/routes";

const PaymentRecieptList = () => {
  const navigate = useNavigate();

  const handlePaymentReceiptDetails = () => {
    navigate(ROUTES_NAVIGATION.VIEWPAYMENTRECEIPT)
  }

  return (
    <ListPage
      isButtonRequired={false}
      headerTopText="Sales / Payment Receipt"
      headerTitle="Payment Reciept"
      listTitle="All Sales Receipt"
      topDetailsList={topDataList}
      tableData={TABLE_DATA}
      tableHeaders={TABLE_HEADERS}
      keyMapping={keyMapping}
      handleViewButton={handlePaymentReceiptDetails}
    />
  );
};

export default PaymentRecieptList;
